<template>
  <div>

    <!-- 唛头打印 -->
    <div v-if="isShow" v-show="false">
      <div ref="label">
        <div class="label">
          <div class="head">
            <div class="time">打印日期：{{ getDate() }}</div>
            <div class=" head-item">
              <span v-if="labelData.order_detail_tag.type == 'FBA'">
                {{ labelData.order_detail_tag.no }}</span>
              箱入れ数：{{ labelData.inspectNum }}
            </div>
            <div class="head-item" style="height: 70px; line-height: 70px;">
              <span>购入数：{{ labelData.confirm_num }}</span>
              <b class="type">{{ labelData.order_detail_tag.type_translate }}</b>
            </div>
          </div>
          <div class="center">
            <div class="left" :class="{ FBA: labelData.order_detail_tag.type == 'FBA' }">
              {{ labelData.type }}
            </div>
            <div class="right">{{ labelData.sorting }}番</div>
          </div>
          <div class="content">

            <div class="row">
              <div class="lab">配货员：</div>
              <div class="val">{{ labelData.p_name }}</div>
            </div>
            <div class="row">
              <div class="lab">业务员：</div>
              <div class="val">{{ labelData.y_name }}</div>
            </div>
            <div class="row">
              <div class="lab">采购员：</div>
              <div class="val">{{ labelData.g_name }}</div>
            </div>
            <div class="row">
              <div class="lab">检品员：</div>
              <div class="val">{{ labelData.j_name }}</div>
            </div>
            <!-- <div class="row">
              <div class="lab">客户名：</div>
              <div class="val">{{ labelData.user_name }}</div>
            </div> -->
            <div class="row">
              <div class="lab">订单号：</div>
              <div class="val">{{ labelData.order_sn }}</div>
            </div>
            <div class="row">
              <div class="lab">商品番号：</div>
              <div class="val">{{ labelData.sorting }}</div>
            </div>
            <div class="row" style="height: 120px;">
              <div class="lab">商品属性：</div>
              <div class="val">
                <span v-for="(item, index) in labelData.detail_y" :key="index">
                  {{ item.key }}:{{ item.value }}</span>
              </div>
            </div>
            <div class="row">
              <div class="lab">交易号：</div>
              <div class="val">{{ labelData.purchase_no }}</div>
            </div>
            <!-- 二维码 -->
            <div class="tiaoxingma">
              <canvas id="express_no" style="height:164px; width:100% ;" />
            </div>
            <div class="row">
              <div class="lab">物流号：</div>
              <div class="val">{{ labelData.order_purchase_express }}</div>
            </div>
            <div class="row">
              <div class="lab">检品单号：</div>
              <div class="val">{{ labelData.inspect_sn }}</div>
            </div>
            <div class="row" style="margin-bottom: 0px;">
              <div class="lab">库位：</div>
              <div class="val">{{ labelData.grid_number }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 打印 -->
    <el-dialog title="上架唛头打印" :visible.sync="dialogVisible" width="750px" center>
      <div class="input">
        <div class="lab">箱入れ数：</div>
        <div class="val"> <el-input v-model="labelData.inspectNum" placeholder="请输入送检数" /></div>
      </div>
      <div class="table">
        <ol>
          <li class="flex05">选择</li>
          <li class="flex2">检品单号</li>
          <li>检品单状态</li>
          <li>检品员</li>
        </ol>
        <ul v-for="(item, index) in labelData.inspect_detail" :key="index">
          <li class="flex05">
            <el-checkbox v-model="item.checked" @change="handleChange(index)"></el-checkbox>
          </li>
          <li class="flex2">{{ item.inspect_sn }}</li>
          <li>{{ item.status }}</li>
          <li>{{ item.j_name }}</li>
        </ul>
      </div>
      <template slot="footer" class="dialog-footer">
        <el-button type="primary" @click="selectStorageLocation(1)">选择库位</el-button>
      </template>
    </el-dialog>
    <!-- 上架唛头 -->
    <el-dialog title="上架唛头打印" :visible.sync="jpDialogVisible" width="450px" center>
      <div class="input">
        <div class="lab">箱入れ数：</div>
        <div class="val"> <el-input v-model="labelData.inspectNum" placeholder="请输入上架数" /></div>
      </div>
      <template slot="footer" class="dialog-footer">
        <el-button type="primary" @click="selectStorageLocation(2)">选择库位</el-button>
      </template>
    </el-dialog>
    <!-- 仓库 -->
    <warehouse v-if="warehouseDialogVisible" :up_data="[]" :type="10" :shelf_type_set="[1, 3,]"
      :order_purchase_ids="[]" />
  </div>
</template>
<script>
import { getDate } from '@/utlis/date'
import warehouse from "@/components/common/warehouse";
export default {
  data() {
    return {
      getDate,
      dialogVisible: false,
      jpDialogVisible: false,
      labelData: {
        sorting: '',
        detail_y: '',
        order_sn: '',
        order_detail_tag: '',
        confirm_num: '',
        inspectNum: '',
        type: '',
        g_name: '',
        p_name: '',
        y_name: '',
        user_name: '',
        purchase_no: '',
        order_purchase_express: '',
        grid_number: '',
      },
      isShow: false,
      warehouseDialogVisible: false, //仓库
      up_data: [],
    }
  },
  components: {
    warehouse,
  },
  methods: {
    // 一维码
    getJsBarcode(selector, data) {
      JsBarcode(selector, data, {
        displayValue: true,
        height: 160,
        width: 6,
        margin: 0,
        fontSize: 0,
        displayValue: false,
        lineColor: "#000000",//设置条和文本的颜色。
      });
      this.$forceUpdate();
    },
    printLabel() {

      let itemData = this.labelData.inspect_detail.find(item => item.checked);
      this.labelData.inspect_sn = itemData.inspect_sn
      this.labelData.j_name = itemData.j_name
      this.isShow = true
      this.$nextTick(() => {
        this.getJsBarcode("#express_no", this.labelData.purchase_no);
        this.$nextTick(() => {
          this.$print(this.$refs.label);
          this.isShow = false
          this.dialogVisible = false
        });
      });
    },
    // 打印上架唛头
    jpPrintLabel() {

      this.isShow = true
      this.$nextTick(() => {
        this.getJsBarcode("#express_no", this.labelData.purchase_no);
        this.$nextTick(() => {
          this.$print(this.$refs.label);
          this.isShow = false
          this.dialogVisible = false
        });
      });
    },

    // 处理复选框变化
    handleChange(index) {
      // 确保只有一个项被选中
      this.labelData.inspect_detail.forEach((item, i) => {
        item.checked = false
      });
      this.labelData.inspect_detail[index].checked = true
      this.$forceUpdate()
    },
    // 选择库位
    selectStorageLocation(type) {
      if (!this.labelData.inspectNum) {
        this.$message({
          message: '请输入箱入れ数',
          type: 'warning'
        })
        return
      }
      if (type == 1) {
        // 检查是否选择了检品单
        let itemData = this.labelData.inspect_detail.find(item => item.checked);
        if (!itemData) {
          this.$message({
            message: '请选择检品单',
            type: 'warning'
          })
          return
        }
      }
      this.warehouseDialogVisible = true
    }

  },
}
</script>
<style scoped>
.label {
  margin: 40px;
  width: 1080px;
  height: 1600px;
  border: 1px solid #000;
  color: #000;

  .head {
    padding: 48px;
    position: relative;

    .time {
      font-size: 32px;
    }

    .head-item {
      font-size: 48px;
      margin-top: 40px;
      line-height: 48px;

      span {
        width: 400px;
        display: inline-block;
        margin-right: 40px;
      }

      .type {
        font-size: 70px;
        font-weight: bold;

      }
    }

  }

  .center {
    display: flex;
    font-size: 65px;
    font-weight: bold;
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
    text-align: center;
    font-weight: bold;

    div {
      padding: 35px 0;
      height: 48px;

    }

    .left {
      width: 700px;
      border-right: 1px solid #000;
    }

    .FBA {
      color: #fff;
      background-color: #000;
    }

    .right {
      flex: 1;
    }
  }

  .content {
    padding: 48px;

    .row {
      display: flex;
      margin-bottom: 30px;
      font-size: 36px;
      height: 40px;
      line-height: 40px;

      .lab {
        width: 240px;
      }

      .val {
        flex: 1;

      }
    }
  }

  .tiaoxingma {
    height: 160px;
    margin: 48px 0;
    overflow: hidden;
  }

  .isNeedRemove {
    height: 160px !important;
  }
}

.input {
  display: flex;
  padding: 0 30px;
  margin-bottom: 20px;

  .lab {
    width: 80px;
    margin-right: 10px;
    line-height: 40px;
  }
}
</style>
